import React, { useState } from "react";
import { useSelector } from "react-redux";
import imageLinks from "assets/images";
import { ReactSVG } from "react-svg";
import { Dropdown, DropdownMenu, DropdownItem } from "reactstrap";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { TICKET_MENTION_PERMISSION } from "components/dashboard/AgentInbox/permissions";
import "./CommentDropdown.scss";

const CommentDropdown = ({
    handleShowDeleteModal,
    handleSetCurrentComment,
    handleResolveComment,
    authorId,
}) => {
    const [dropdownOpen, toggleDropdown] = useState(false);
    const {
        user: { userId },
    } = useSelector((state) => state.auth);

    return (
        <Dropdown
            isOpen={dropdownOpen}
            className={`added__collection`}
            direction='up'
            id='comment__dropdown'
            toggle={() => toggleDropdown((prevState) => !prevState)}>
            <ReactSVG
                src={imageLinks?.icons?.carbonMore}
                onClick={() => toggleDropdown((prevState) => !prevState)}
                className='comment__dropdown__icon'
            />
            <DropdownMenu className='comment__dropdown__menu '>
                {authorId === userId && (
                    <>
                        <ComponentAccessControl
                            baseResources={TICKET_MENTION_PERMISSION}>
                            <DropdownItem onClick={handleSetCurrentComment}>
                                Edit
                            </DropdownItem>
                        </ComponentAccessControl>
                        <ComponentAccessControl
                            baseResources={TICKET_MENTION_PERMISSION}>
                            <DropdownItem onClick={handleShowDeleteModal}>
                                Delete
                            </DropdownItem>
                        </ComponentAccessControl>
                    </>
                )}
                <ComponentAccessControl baseResources={TICKET_MENTION_PERMISSION}>
                    <DropdownItem onClick={handleResolveComment}>
                        Resolve
                    </DropdownItem>
                </ComponentAccessControl>
            </DropdownMenu>
        </Dropdown>
    );
};

export default CommentDropdown;
